import React, { useState } from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Container,
  Paper
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useAuthenticator } from '@aws-amplify/ui-react';
import UnifiedSettingsDialog from './dialogs/UnifiedSettingsDialog';
import EventAggregatorApp from './EventAggregatorApp';
import { useSettings } from '../contexts/settingsContext';

/**
 * OperatorApp - Interface for operators
 * New functionality to be defined
 */
export default function OperatorApp() {
  const { signOut } = useAuthenticator();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [eventAggregatorOpen, setEventAggregatorOpen] = useState(false);
  const settings = useSettings();

  const handleSignOut = () => signOut();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* App Bar */}
      <AppBar position="static" sx={{ bgcolor: '#2d3e50' }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Operator Panel
          </Typography>

          <IconButton
            color={eventAggregatorOpen ? "secondary" : "inherit"}
            onClick={() => setEventAggregatorOpen(!eventAggregatorOpen)}
            title="Event Aggregator"
          >
            <TimelineIcon />
          </IconButton>

          <IconButton
            color="inherit"
            onClick={() => setSettingsOpen(true)}
            title="Settings"
          >
            <SettingsIcon />
          </IconButton>

          <IconButton
            color="inherit"
            onClick={handleSignOut}
            title="Sign Out"
          >
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content Area */}
      <Box sx={{ mt: 1, mb: 1, mx: 1, flexGrow: 1, overflow: 'auto' }}>
        {eventAggregatorOpen ? (
          <EventAggregatorApp />
        ) : (
          <Box sx={{ maxWidth: 'lg', mx: 'auto' }}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h5" gutterBottom>
                Operator Dashboard
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Click the Event Aggregator icon to get started.
              </Typography>
            </Paper>
          </Box>
        )}
      </Box>

      {/* Settings Dialog */}
      <UnifiedSettingsDialog
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        deleteConfirmation={settings.deleteConfirmation}
        onDeleteConfirmationChange={settings.handleDeleteConfirmationChange}
        autoEnableVoice={settings.autoEnableVoice}
        onAutoEnableVoiceChange={settings.setAutoEnableVoice}
        stealthMode={settings.stealthMode}
        onStealthModeChange={settings.setStealthMode}
        removeBg={settings.removeBg}
        setRemoveBg={settings.setRemoveBg}
        sliderValue={settings.sliderValue}
        setSliderValue={settings.setSliderValue}
        maxFacesValue={settings.maxFacesValue}
        setMaxFacesValue={settings.setMaxFacesValue}
        showBoundingBoxes={settings.showBoundingBoxes}
        setShowBoundingBoxes={settings.setShowBoundingBoxes}
        immediateFaceMatch={settings.immediateFaceMatch}
        setImmediateFaceMatch={settings.setImmediateFaceMatch}
        updateCharacteristicsOnMatch={settings.updateCharacteristicsOnMatch}
        setUpdateCharacteristicsOnMatch={settings.setUpdateCharacteristicsOnMatch}
        locationHighAccuracy={settings.locationHighAccuracy}
        setLocationHighAccuracy={settings.setLocationHighAccuracy}
        locationAcquisitionTimeout={settings.locationAcquisitionTimeout}
        setLocationAcquisitionTimeout={settings.setLocationAcquisitionTimeout}
        locationCacheMaxAge={settings.locationCacheMaxAge}
        setLocationCacheMaxAge={settings.setLocationCacheMaxAge}
        compressionQuality={settings.compressionQuality}
        setCompressionQuality={settings.setCompressionQuality}
        autoAdjustCompression={settings.autoAdjustCompression}
        setAutoAdjustCompression={settings.setAutoAdjustCompression}
        autoCreateEventOnAIMatch={settings.autoCreateEventOnAIMatch}
        setAutoCreateEventOnAIMatch={settings.setAutoCreateEventOnAIMatch}
        aggregatorEventLimit={settings.aggregatorEventLimit}
        setAggregatorEventLimit={settings.setAggregatorEventLimit}
      />
    </Box>
  );
}
